export default __webpack_public_path__ + "static/1920_1930-35d43bce35958926c4d5ace58bb9f41c.mp4";